import variableColors from "@/base/global/variables/figma.colors.json";

export const rateThemeToken: any = {
  starBg: variableColors["ColorFigmaNeutralGrayscaleGray40"],
  starColor: variableColors["ColorFigmaComplementaryBlue40"],

  marginXS: 4,
  starSize: 14,
  starSizeLG: 24,
  starHoverScale: "scale(1)",
};
